import { Chips } from 'primereact/chips'
import { Dropdown } from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext'
import { RadioButton } from 'primereact/radiobutton'
import { classNames } from 'primereact/utils'
import React from 'react'
import { Controller } from 'react-hook-form'

const FIELD_TYPES = {
  INPUT: 'input',
  DROPDOWN: 'dropdown',
  RADIO: 'radio',
  CHIPS: 'chips'
}

function FormInputsFields({ type, label, name, control, fieldClasses, options, optionDisabled = null, errors, additionalInfo, scrollHeight = '250px', disabled = false, valueArr, value, customClass, onChange, ...restProps }) {

  switch (type) {
    case FIELD_TYPES.INPUT:
      return (
        <div className="p-fluid field">
          <label className='font-medium'>{label}</label>
          {additionalInfo && additionalInfo}
          <Controller name={name} control={control} render={({ field, fieldState }) => (
            <InputText
              {...field}
              id={field[name]}
              disabled={disabled}
              className={classNames({ 'p-invalid': fieldState.error })}
              {...restProps}

            />
          )} />
          <span className="p-error text-sm pt-2">{errors[name]?.message}</span>
        </div>
      )

    case FIELD_TYPES.DROPDOWN:
      return (
        <div className="p-fluid field">
          <label className='font-medium'>{label}</label>
          {additionalInfo && additionalInfo}
          <Controller name={name} control={control} render={({ field, fieldState }) => (
            <Dropdown
              {...field}
              disabled={disabled}
              options={options || []}
              className={classNames({ 'p-invalid': fieldState.error })}
              id={field[name]}
              {...restProps}
            />
          )} />
          <span className="p-error text-sm pt-2">{errors[name]?.message}</span>
        </div>
      )

    case FIELD_TYPES.RADIO:
      return (
        <>
          {options?.map((option, idx) =>
            <div className={classNames("my-3", customClass)} key={idx}>
              <label className="font-medium">{valueArr[option]}</label>
              <RadioButton
                className={classNames("ml-3", fieldClasses)}
                value={value}
                onChange={() => onChange(option)}
                checked={valueArr[option] === value}
                {...restProps}
              />
            </div>
          )}
        </>
      )
    case FIELD_TYPES.CHIPS:
      return (
        <div>
          <label>{label}</label>
          {additionalInfo && additionalInfo}
          <Controller name={name} control={control} render={({ field, fieldState }) => (
            <Chips
              {...field}
              id={field[name]}
              className={classNames({ 'p-invalid': fieldState.error })} />
          )} />
          <span className="p-error text-sm pt-2">{errors[name]?.message}</span>

        </div>
      )
    default:
      return <></>
  }
}

export default FormInputsFields